module.exports = __webpack_public_path__ + "media/images/q_key-bf70f162de7124c17206d8dde0b65e9d.jpeg";